module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/screen-macbook-casestudy@2x-c4fba0386861df2a080365a5fbf60165.png";